import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://aee917207763f0de7a7957f65d9ba0e2@o545464.ingest.us.sentry.io/4508397211549696',
  sendDefaultPii: true,
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  integrations: [],
});
